import React from "react";
import {
  Button
  // CancelButton
} from "../button/button";
import { ContentsContainer } from "../card/cardcontainer";
import { LightText } from "../lightText/lighttext";
import { BoldText } from "../normalText/normalText";
import styles from "./ussd.module.css";
import { BiCopy } from "react-icons/bi";
import Select from "react-select";
import { wqSelectStyles } from "../../utils/selectTheme";

const Spinner = () => (
  <div style={{ display: "flex", justifyContent: "center", paddingTop: "24px" }}>
    <div className="spinner" style={{ borderColor: "red", borderTop: "transparent" }}></div>
    <span>Loading...</span>
  </div>
);

// Pure presentation: bank picker (tab 1) + generated code + confirm action
// (tab 2). Code-generation and confirm behavior are injected by the caller,
// so live and test-mode USSD can share this without duplicating markup.
export const UssdSelector = ({
  tab,
  banks,
  onSelectBank,
  isLoading,
  bankCode,
  selectedBank,
  onCopyCode,
  onConfirm,
  confirmText = "Click here if you've completed payment",
  banner,
}) => (
  <ContentsContainer>
    {banner}
    {tab === 1 && (
      <div className={styles.contents}>
        <BoldText>Pay by dailing USSD Code on your mobile device</BoldText>
        <div className={styles.inputContainer}>
          <Select
            styles={wqSelectStyles()}
            placeholder={<p style={{ margin: 0 }}>Choose your bank to start the payment</p>}
            options={banks}
            onChange={onSelectBank}
          />
        </div>
        {isLoading && <Spinner />}
      </div>
    )}

    {tab === 2 && (
      <div className={styles.contentsBetween}>
        <div className={styles.text}>
          <LightText align="center">
            Copy the following code below to your mobile device and dial to
            complete this transaction with {selectedBank ?? "---"}
          </LightText>
        </div>
        <br />
        <BoldText>
          {bankCode}{" "}
          <span style={{ cursor: "pointer" }} onClick={onCopyCode}>
            <BiCopy color="#C4C4C4" />
          </span>
        </BoldText>
        <br />
        <div className={styles.buttonContainer}>
          <Button onClick={onConfirm} text={confirmText} active={true} />
          {/* <CancelButton text="cancel" onClick={CancelHandler}/> */}
        </div>
      </div>
    )}
  </ContentsContainer>
);